import {
  addLoadApi,
  deleteTransactionApi,
  getAccountList,
  getConsignorTransactionList,
  handleKeyDown,
} from "_services";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { Images } from "constants";
import images from "constants/images";
import { UserContext } from "context";
import { utils } from "helper";
import {
  AddBankAccount,
  AddClaimForConsignor,
  AddEditLrModal,
  AddLrModal,
  AttachedFileModal,
  BankListCanvas,
  ConfirmModalFor,
  EditConsignorFreight,
  LrDetailModal,
  OtherExpenseModal,
  PaymentVoucher,
  SelectLrForConsignor,
} from "modals";
import AddChargeModal from "modals/AddChargeModal/AddChargeModal";
import AddEditConsignor from "modals/AddEditConsignor/AddEditConsignor";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BsChevronDown } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import './consignorFreight.css'
import useDocumentTitle from "hooks/useDocumentTitle";

const ConsignorFreight = (props) => {
  const { freightId, callApi, tripDetais, endTripApiCall } = props;
  const navigate = useNavigate();
  useDocumentTitle("Party Freight | T360");
  const { globTripDetails, setBankDetails, masterData, userSettingPermission } =
    useContext(UserContext);
  const [selectLrOpen, setSelectLrOpen] = useState(false);
  const [paySupplierOpen, setPaySupplierOpen] = useState(false);
  const [consignorTransList, setConsignorTransList] = useState([]);
  const [consignorTransDetails, setConsignorTransDetails] = useState([]);
  const [flag, setFlag] = useState(false);
  // const [isOpenCharge, setIsOpenCharges] = useState(false);
  const [isOpenCharge, setIsOpenCharges] = useState({ open: false, type: "" });
  const [isOpenClaim, setIsOpenClaim] = useState(false);
  const [lrDetails, setLrDetails] = useState();
  const [lrId, setLrId] = useState();
  const [freghtSummary, setFreghtSummary] = useState();
  const [canvasOpen, setCanvasOpen] = useState(false);
  const [showAddBank, setShowAddBank] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [isOpenExpense, setIsOpenExpense] = useState({ open: false, type: "" });
  const [editLrAmount, setEditLrAmount] = useState(false);
  const [editData, setEditData] = useState("");
  const [initalEditData, setInitialEditData] = useState("");
  const [showLrDetail, setShowLrDetail] = useState(false);
  const [showAddLR, setShowAddLR] = useState(false);
  const [accountLoading, setAccountLoading] = useState(false);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [transationDetails, setTransationDetails] = useState();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showAttachedModal, setShowAttachedModal] = useState({
    open: false,
    data: [],
  });
  const [selectParty, setSelectParty] = useState(false);
  const [isAddConsignor, setIsAddConsignor] = useState(false);
  const [showPrefield, setShowingPrefield] = useState(false);
  const [showSelectLr, setShowSelectLr] = useState(false);
  const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
  const [selectedLr, setSelectedLr] = useState([]);
  const [selectLRListID, SetSelectLRListID] = useState("");
  const [isSelectLR, setIsSelectLR] = useState(false);
  const [isAddLrLater, setIsAddLrLater] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState([]);


  // Inside your map or loop
  const toggleDropdown = (id) => {
    setOpenDropdowns((prev) =>
      prev.includes(id)
        ? prev.filter((dropdownId) => dropdownId !== id) // Remove if exists
        : [...prev, id] // Add if not exists
    );
  };

  const toggleAddClaimCanvas = () => {
    setSelectLrOpen(!selectLrOpen);
  };

  const togglePayClaimCanvas = () => {
    setPaySupplierOpen(!paySupplierOpen);
  };

  useEffect(() => {
    getConsignorTransActionHandler(freightId);
    // getAccountListHandler(globTripDetails?.supplier_id?._id);
  }, [freightId, tripDetais]);

  useEffect(() => {
    // const list = consignorTransList?.find((i) => i?._id === lrId);
    // setFreghtSummary(list);

    let foundItem = null;

    consignorTransList?.forEach((item) => {
      const lrItem = item.lr_list?.find((lr) => lr._id == lrId);
      if (lrItem) {
        foundItem = lrItem;
      }
    });
    setFreghtSummary(foundItem);
  }, [lrId]);

  useEffect(() => {
    if (consignorTransList?.length) {
      // if (!lrId) {
      //   setLrId(consignorTransList[0]?._id);
      // }
      const result = consignorTransList.flatMap((item) =>
        item.lr_list.map((lr) => ({
          consignor_id: lr.consignor_id._id,
          lr_id: lr._id,
        }))
      );

      setSelectedLr(result);

      if (!lrId) {
        if (consignorTransList?.length) {
          const firstLrList = consignorTransList[0]?.lr_list;

          if (firstLrList?.length) {
            setLrId(firstLrList[0]?._id);
          }
        }
      }
    }
  }, [consignorTransList]);

  useEffect(() => {
    if (transationDetails) {
      setConfirmModalShow(true);
    }
  }, [transationDetails]);

  useEffect(() => {
    if (endTripApiCall === "call") {
      callBackCharge();
    }
  }, [endTripApiCall]);

  const arryOptions = [
    { label: "Arjun", value: "01" },
    { label: "Anvit", value: "02" },
  ];

  const handleDelete = async () => {
    const payload = {
      company_id: StorageService?.getCompanyId(),
      transaction_id: transationDetails?.transaction_id || paymentVoucherOpen?.transaction_id,

    };
    try {
      setDeleteLoading(true);
      const res = await deleteTransactionApi(payload);
      if (res?.responseCode == 200) {
        toast.success(res?.responseMessage);
        setConfirmModalShow(false);
        setTransationDetails("");
        getConsignorTransActionHandler(freightId);
        callApi();
        setDeleteLoading(false);
        setPaymentVoucherOpen(false)
      } else {
        setDeleteLoading(false);
        // toast.error(res?.responseMessage);
      }
    } catch (error) {
      setDeleteLoading(false);
      toast.error(error?.message);
    }
  };

  const getConsignorTransActionHandler = async (freightId, lr_id = "", selectedLRid) => {
    setFlag(true);
    try {
      const res = await getConsignorTransactionList({
        company_id: StorageService.getCompanyId(),
        trip_id: freightId,
      });

      if (res?.responseCode === 200) {
        setFlag(false);
        setConsignorTransDetails(res?.data?.trip);
        setConsignorTransList(res?.data?.trip?.to_location);
        if (!selectedLRid) {
          const list = res?.data?.trip?.to_location[0]?.lr_list?.find(
            (i) => i?._id === lrId
          );
          setFreghtSummary(list);
        } else {
          const list = res?.data?.trip?.to_location.find((i) => i?._id == selectedLRid).lr_list.find(
            (i) => i?._id === lr_id
          );
          setFreghtSummary(list);
        }


      } else {
        setFlag(false);
      }
    } catch (error) {
      setFlag(false);
    }
  };

  const getAccountListHandler = async (id) => {
    setAccountLoading(false);
    try {
      const res = await getAccountList({
        company_id: StorageService?.getCompanyId(),
        vendor_type: 1,
        vendor_id: id,
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.bank_account?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?.id,
          };
        });
        setAccountList(details);
      } else {
        setAccountLoading(false);
      }
    } catch (error) {
    }
  };

  const openChargesHandle = async (data, name) => {
    if (data?.lr_status >= 6) {
      toast?.error("This Lr bill raised is completed or cancelled, you cannot add charges now.");
    } else {
      setLrId(data?._id)
      await setLrDetails(data);
      setIsOpenCharges({ open: true, type: name });
    }


  };

  const openClaimHandle = async (data) => {
    await setLrDetails(data);
    setIsOpenClaim(data);
  };

  const callBackCharge = () => {

    getConsignorTransActionHandler(freightId);
    setIsOpenClaim(false);
    // callApi();
    setIsOpenCharges({ open: false, type: "" });
  };

  const callBackAddAccount = () => {
    setCanvasOpen(true);
    getAccountListHandler(globTripDetails?.supplier_id?._id);
  };

  const closeClaimModal = () => {
    setIsOpenClaim(false);
    setBankDetails("");
  };

  const submitUpdateHandle = () => { };

  const handleDelteSubmit = (i) => {
    setTransationDetails(i);
  };

  const handleDetailsAction = (data) => {
    setShowLrDetail(data);
  };

  const handleNextModal = (data) => {
    setShowLrDetail(!showLrDetail);
    setShowAddLR(data);
  };

  const callbackTotal = () => {
    callBackCharge()

  };

  const callBackDataLr = (data) => {
    // callApi();
    getConsignorTransActionHandler(freightId);
    // if (data?.branch_id) {
    //   addTable();
    //   const newList = [...listOfLr];
    //   newList[indexofTable].list[listOfLr[indexofTable].list.length] = data;
    //   const newSelect = [...selectedLr];
    //   newSelect[indexofTable]?.list.push(data);
    //   setSelectedLr(newSelect);
    //   setListOfLr(newList);
    // }
  };

  const addLoadWithoutLr = async (prtyData) => {
    const payload = {
      company_id: StorageService.getCompanyId(),
      trip_id: freightId,
      lr_list_id: selectLRListID,
      lr_id: "",
      consignor_id: prtyData?.party?.value,
      eway_bill_number: null,
      eway_bill_date: "",
      eway_expiry_date: "",
    };

    try {
      setIsAddLrLater(true)
      const res = await addLoadApi(payload);
      if (res.responseCode == 200) {

        setIsAddLrLater(false)
        setSelectParty(false);
        getConsignorTransActionHandler(freightId, res?.data?.lr_id, selectLRListID);
        setLrId(res?.data?.lr_id)
      } else {
        setIsAddLrLater(false)
      }
    } catch (error) {
      setIsAddLrLater(false)
    }
  };

  const callbackSelectLr = async (prtyData, consignor_id) => {
    const payload = {
      company_id: StorageService.getCompanyId(),
      trip_id: freightId,
      lr_list_id: selectLRListID,
      lr_id: prtyData?._id,
      consignor_id: consignor_id,
      eway_bill_number: null,
      eway_bill_date: "",
      eway_expiry_date: "",
    };


    try {
      const res = await addLoadApi(payload);

      if (res.responseCode == 200) {

        setShowSelectLr(false);
        setIsSelectLR(false)
        getConsignorTransActionHandler(freightId, prtyData?._id, selectLRListID);
        setLrId(prtyData?._id)
      } else {
        setIsSelectLR(false)
      }
    } catch (error) {
      setIsSelectLR(false)
    }
  };

  const noTransactionStyle = {
    padding: "10px 0",
    fontSize: "14px",
    color: "#999",
    textAlign: "center",
    borderBottom: "1px solid #ddd",
  };

  const getCategoriesNames = (item) => {
    if (item?.category_type == 1) {
      return <>{item?.categories[0]?.category?.name}</>;
    }

    if (item?.category_type == 2) {
      return <>{item?.category_name}</>;
    }
  };

  const NoTransactionRow = () => (
    <div style={noTransactionStyle}>No Transaction</div>
  );

  let chargeProps = {
    isOpen: isOpenCharge.open,
    closeModal: (e) => setIsOpenCharges({ open: false, type: "" }),
    isOpenCharge: isOpenCharge,
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Freight",
    submitTitle: "Add Freight",
    cancelButtonTitle: "Send for Approval",
    tripId: freightId,
    lrDetails: lrDetails,
    callBackCharge: callBackCharge,
    consignorTransList: consignorTransList,
    userSettingPermission: userSettingPermission,
    tripDetais: consignorTransDetails
  };

  let claimProps = {
    isOpen: isOpenClaim,
    closeModal: closeClaimModal,
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Claim",
    tripId: freightId,
    lrDetails: lrDetails,
    callBackCharge: callBackCharge,
    setCanvasOpen: setCanvasOpen,
    canvasOpen: canvasOpen,
    accountList: accountList,
    callApi: callApi,
    consignorTransList: consignorTransList,
    consignorTransDetails: consignorTransDetails,
    tripDetais: consignorTransDetails
  };

  let bankListProps = {
    setCanvasOpen: setCanvasOpen,
    canvasOpen: canvasOpen,
    setShowAddBank: setShowAddBank,
    accountList: accountList,
    setIsOpenFreight: setIsOpenClaim,
  };

  const accountClose = () => {
    setShowAddBank(false);
    setCanvasOpen(true);
  };

  let firstAddBank = {
    isOpen: showAddBank,
    closeModal: accountClose,
    headerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Bank Account",
    submitTitle: "Continue",
    callBackAddAccount: callBackAddAccount,
  };

  let otherExpenseProps = {
    isOpen: isOpenExpense.open,
    modalType: isOpenExpense.type,
    closeModal: (e) =>
      setIsOpenExpense({ ...isOpenExpense, open: false, type: "" }),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Other",
    submitTitle: "Approval",
    tripId: freightId,
    callBackFreight: callBackCharge,
    tripDetais: consignorTransDetails
    // transactionList: transactionList,
  };

  // let propsObject = {
  //   show: editLrAmount,
  //   closeModal: (e) => setEditLrAmount(false),
  //   title: "Update",
  //   submitTitle: "Update",
  //   onSubmit: submitUpdateHandle,
  //   icon: images.EDIT,
  //   // isLoadding:ewayLoading,
  //   disabled: initalAmount == amount,
  // };

  let addTotalProps = {
    isOpen: editLrAmount,
    closeModal: (e) => {
      setEditLrAmount(false);
    },
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Edit Freight Amount",
    submitTitle: "Update Amount",
    tripId: freightId,
    data: editData,
    setEditData: setEditData,
    icon: images.EDIT,
    callbackTotal: callbackTotal,
  };

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: (e) => {
      setConfirmModalShow(false);
      setTransationDetails("");
    },
    title: "Confirm",
    submitTitle: "Delete",
    onSubmit: handleDelete,
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
    isLoadding: deleteLoading,
    disabled: deleteLoading,
  };

  let attachedModal = {
    isOpen: showAttachedModal?.open,
    closeModal: (e) =>
      setShowAttachedModal((pre) => ({ ...pre, open: false, data: [] })),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _AttachmentModal",
    modalTitle: "Attachment",
    submitTitle: "Add",
    cancelButtonTitle: "Cancel",
    showAttachedModal: showAttachedModal,
    // getMaterial: (e) => getMaterial()
    // getBanner: (e) => getBanner()
  };

  const paymentVoucherProps = {
    paymentVoucherOpen: paymentVoucherOpen,
    closeModal: () => setPaymentVoucherOpen(false),
    voucherId: paymentVoucherOpen?._id,
    oprnDeleteModal: setConfirmModalShow
  };

  let selectPartyModal = {
    isOpen: selectParty,
    closeModal: (e) => setSelectParty(false),
    addButtonAction: (e) => setIsAddConsignor(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add LR",
    submitTitle: "Select LR",
    nextModal: (e) => setShowSelectLr(e),
    showPrefield: showPrefield,
    showingPrefield: (e) => setShowingPrefield(e),
    secondSubmit: addLoadWithoutLr,
    isAddLrLater: isAddLrLater,
    filledLocation: {
      from: { from_city: "ndfdn" },
      to: { to_city: "fndifn" }
    },
    branchFirmIdForTrip: consignorTransDetails?.firm_id

  };

  let selectLrModalProps = {
    isOpen: showSelectLr,
    closeModal: (e) => setShowSelectLr(false),
    onSubmit: (e) => setShowSelectLr(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: " _dashCommon_Modal _xxlModal",
    modalTitle: "Select LR",
    submitTitle: "null",
    setIsSelectLR: setIsSelectLR,
    isSelectLR: isSelectLR,
    // indexofTable: indexofTable,
    // listOfLr: listOfLr,
    callbackSelectLr: callbackSelectLr,
    selectedLr: selectedLr,
    // consignorList: consignorList,
    // branchList: branchList,
    // setSelectParty: setSelectParty,
    branchFirmId: consignorTransDetails?.firm_id?._id,
    tripDetais: tripDetais
  };

  return (
    <>
      {consignorTransList?.length > 0 ? (
        <div className="anv_tripTab_otr">
          <div className="row anvRG_gap">
            <div className="col-12">
              <div className="anvFrightUpp_tabBx_tp" style={{ paddingBottom: '0px' }}>
                <div className="anvFrightInden_detailBx_tp">
                  <div className="sprt_dix nW_sprtDix">
                    <p>Revenue</p>
                    <h2>{`₹ ${(consignorTransDetails?.consignor_freight
                      ?.total_freight
                      ? consignorTransDetails?.consignor_freight?.total_freight
                      : 0 + consignorTransDetails?.consignor_freight?.receivable
                        ? consignorTransDetails?.consignor_freight?.receivable
                        : 0 - consignorTransDetails?.consignor_freight?.payble
                          ? consignorTransDetails?.consignor_freight?.payble
                          : 0
                    )?.toFixed(2)}`}</h2>
                  </div>

                  <div className="sprt_dix nW_sprtDix">
                    <p>Total Balance</p>
                    <h2>{`₹ ${consignorTransDetails?.consignor_freight?.balance
                      ? consignorTransDetails?.consignor_freight?.balance.toFixed(
                        2
                      )
                      : 0?.toFixed(2)
                      }`}</h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="anv_freightTable_otr_tpBx _anvfrg_table">
                <div className="anv_freightTable_detail_tpBx" style={{ width: '100%', maxWidth: '1250px' }}>
                  {consignorTransList?.map((main, index) => {
                    return (
                      <div className="accordionTable_view" key={main?._id}>
                        <div className="__loadFx_bxs">
                          <p>{`Loads for ${main?.to_city}, ${main?.to_state}`}</p>
                          {tripDetais?.trip_status != 5 && <button
                            onClick={() => {
                              SetSelectLRListID(main?._id);
                              setSelectParty(true);
                            }}
                          >
                            Add Loads
                          </button>}
                        </div>

                        {main?.lr_list?.length > 0 ? (
                          <div className="accordion" id="accordionConFright">
                            {main &&
                              main?.lr_list?.map((item, index) => {
                                console.log("item",item)
                                const isFirstItem = index === 0;
                                const isOpen = lrId === item?._id;
                                return (
                                  <div
                                    className="accordion-item"
                                    key={`${index}_${item?._id}`}
                                  >
                                    <h2 className="accordion-header">
                                      <div className="PickNdrop_placeBx">
                                        <div className="_cnFr_listsBx">
                                          <div>
                                            <div className="_pdTransport_dl">
                                              <h5
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  navigate(
                                                    `/account/consignor/details/${item?.consignor_id?._id}?tab=1`
                                                  )
                                                }
                                              >
                                                {item?.consignor_id?.name}
                                              </h5>
                                              {item?.is_upgrade && (
                                                <span>
                                                  {item?.invoice_number
                                                    ? `INV- ${item?.invoice_number}`
                                                    : ""}
                                                </span>
                                              )}
                                              {item?.is_upgrade && (
                                                <span
                                                  style={{ cursor: "pointer" }}
                                                  onClick={(e) =>
                                                    item?.lr_number
                                                      ? handleDetailsAction(
                                                        item
                                                      )
                                                      : ""
                                                  }
                                                >
                                                  {item?.lr_number
                                                    ? `#${item?.lr_number}`
                                                    : ""}
                                                </span>
                                              )}
                                              {!item?.is_upgrade && (
                                                <>{tripDetais?.trip_status != 5 && <h4
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => handleDetailsAction(
                                                    item
                                                  )}
                                                >
                                                  + Add LR Details
                                                </h4>}</>

                                              )}
                                            </div>

                                            <div className="_inrPd">
                                              <h4>{item?.from_location}</h4>
                                              <img
                                                src={
                                                  Images.ROUTTRUCKICON.default
                                                }
                                                alt=""
                                              />
                                              <h4>{item?.to_location}</h4>
                                              <span
                                                className={
                                                  masterData?.lr_status[
                                                    item?.lr_status
                                                  ] === "Pending"
                                                    ? "_lrPending_status"
                                                    : masterData?.lr_status[
                                                      item?.lr_status
                                                    ] === "In Transit"
                                                      ? "_lrInTransit_status"
                                                      : masterData?.lr_status[
                                                        item?.lr_status
                                                      ] === "At Party Point"
                                                        ? "_lrPartyPoint_status"
                                                        : masterData?.lr_status[
                                                          item?.lr_status
                                                        ] === "Delivered"
                                                          ? "_lrDelivered_status"
                                                          : masterData?.lr_status[
                                                            item?.lr_status
                                                          ] === "Bill Raised"
                                                            ? "_lrBillRaised_status"
                                                            : masterData?.lr_status[item?.lr_status] ===
                                                              "Cancelled"
                                                              ? "_lrCanceled_status"
                                                              : ""
                                                }
                                              >
                                                {
                                                  masterData?.lr_status[
                                                  item?.lr_status
                                                  ]
                                                }
                                              </span>
                                            </div>
                                          </div>

                                          <div className="_flxRight" style={{ alignItems: 'center' }}>
                                            {/* <button
                                              className="_numEdits_btn"
                                              onClick={() => {

                                                if (tripDetais?.trip_status != 5) {
                                                  setEditData(item);
                                                  setInitialEditData(
                                                    item?.lr_freight
                                                  );
                                                  setEditLrAmount(true);
                                                }

                                              }}
                                            >
                                              <span>
                                                ₹{" "}
                                                {item?.lr_freight?.total_freight?.toFixed(
                                                  2
                                                )}
                                              </span>
                                              {tripDetais?.trip_status != 5 && <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="17"
                                                height="17"
                                                viewBox="0 0 17 17"
                                                fill="none"
                                              >
                                                <path
                                                  d="M3.64706 4.52942H2.76471C2.29668 4.52942 1.84782 4.71534 1.51687 5.04629C1.18592 5.37724 1 5.8261 1 6.29413V14.2353C1 14.7033 1.18592 15.1522 1.51687 15.4831C1.84782 15.8141 2.29668 16 2.76471 16H10.7059C11.1739 16 11.6228 15.8141 11.9537 15.4831C12.2847 15.1522 12.4706 14.7033 12.4706 14.2353V13.353"
                                                  stroke="#0049D7"
                                                  strokeWidth="1.76469"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                                <path
                                                  d="M11.5881 2.7648L14.2352 5.41186M15.4572 4.16333C15.8047 3.81582 16 3.34449 16 2.85304C16 2.36158 15.8047 1.89025 15.4572 1.54274C15.1097 1.19523 14.6384 1 14.1469 1C13.6555 1 13.1841 1.19523 12.8366 1.54274L5.41162 8.94128V11.5883H8.05868L15.4572 4.16333Z"
                                                  stroke="#0049D7"
                                                  strokeWidth="1.76469"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                              </svg>}
                                            </button> */}

                                            {item?.lr_status !== 7 && <span className={item?.lr_status !== 6 ? "tagBxs pending" : "tagBxs approved"}>{`${item?.lr_status == 6 ? "Bill Raised" : "Bill Pending"}`}</span>
                                            }
                                            {item?.lr_status !== 7 && <>{item?.lr_status !== 6 ? <button className="anime-btn __extendEw_btn" style={{ marginLeft: '6px', marginRight: '10px' }} onClick={() => navigate("/invoicing/createbillraise", {
                                              state: {
                                                consignor: item?.consignor_id,
                                                branch: item?.branch_id,
                                              },
                                            })}>Raise Bill</button> :

                                              item?.billraise_id?._id && <button className="anime-btn __extendEw_btn" style={{ marginLeft: '6px', marginRight: '10px' }} onClick={() => navigate(`/invoicing/details/${item?.billraise_id?._id}`)}>View Bill</button>}</>}

                                            <button
                                              className={`accordion-button ${isOpen ? "" : "collapsed"
                                                }`}
                                              type="button"
                                              data-bs-toggle="collapse"
                                              data-bs-target={`#${index}_${item?._id}`}
                                              aria-expanded={
                                                isOpen ? "true" : "false"
                                              }
                                              aria-controls={`${index}_${item?._id}`}
                                              onClick={() => setLrId(item?._id)}
                                            >
                                              <svg
                                                className="cstCevs"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="18"
                                                height="18"
                                                viewBox="0 0 18 18"
                                                fill="none"
                                              >
                                                <path
                                                  d="M4.91862 6.69936C4.87178 6.6502 4.81668 6.61176 4.75647 6.58625C4.69625 6.56074 4.63211 6.54865 4.56769 6.55068C4.50327 6.5527 4.43984 6.5688 4.38102 6.59805C4.3222 6.6273 4.26915 6.66913 4.22488 6.72116C4.18062 6.77319 4.14602 6.83439 4.12305 6.90127C4.10008 6.96815 4.08919 7.0394 4.09102 7.11095C4.09284 7.18251 4.10733 7.25296 4.13367 7.31829C4.16 7.38362 4.19767 7.44255 4.24451 7.49172L8.6601 12.1238C8.75119 12.2194 8.87179 12.2727 8.99715 12.2727C9.12251 12.2727 9.24312 12.2194 9.33421 12.1238L13.7503 7.49172C13.7982 7.44288 13.8368 7.38396 13.864 7.31839C13.8912 7.25282 13.9064 7.1819 13.9087 7.10975C13.911 7.0376 13.9004 6.96566 13.8774 6.89811C13.8545 6.83056 13.8197 6.76875 13.7751 6.71626C13.7305 6.66377 13.6769 6.62165 13.6175 6.59235C13.5581 6.56305 13.494 6.54715 13.4291 6.54558C13.3641 6.54401 13.2995 6.5568 13.239 6.5832C13.1785 6.60959 13.1233 6.64908 13.0767 6.69936L8.99715 10.9783L4.91862 6.69936Z"
                                                  fill="#1450EC"
                                                />
                                                <circle
                                                  cx="9"
                                                  cy="9"
                                                  r="8.59091"
                                                  transform="rotate(-180 9 9)"
                                                  stroke="#0049D7"
                                                  strokeWidth="0.818182"
                                                />
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </h2>

                                    <div
                                      id={`${index}_${item?._id}`}
                                      className={`accordion-collapse collapse ${isOpen ? "show" : ""
                                        }`}
                                      data-bs-parent="#accordionConFright"
                                    >
                                      <div className="__nW_tblSpx">
                                        <div className="anv_fr_detailHead">
                                          {/* Map start */}

                                          <div class="accordion" id="accordionPanelsStayOpenExample">

                                            <div id="panelsStayOpen-headingOne">
                                              <h4 style={{ minHeight: '43px', paddingRight: '1em' }}>
                                                <div className="_nW_h4Inner">
                                                  <p className="__avgFrieght">Total Freight</p>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                  <span className="__rtAmt">₹{" "}
                                                    {item?.lr_freight?.qty && item?.lr_freight?.rate
                                                      ? (item.lr_freight.qty * item.lr_freight.rate).toFixed(2)
                                                      : item?.lr_freight?.total_freight
                                                        ? item.lr_freight.total_freight.toFixed(2)
                                                        : (0).toFixed(2)
                                                    }

                                                  </span>
                                                  {item?.lr_status != 6 && <button
                                                    className=""
                                                    onClick={() => {

                                                      if (tripDetais?.trip_status != 5) {
                                                        setEditData(item);
                                                        setInitialEditData(
                                                          item?.lr_freight
                                                        );
                                                        setEditLrAmount(true);
                                                      }

                                                    }}
                                                  >

                                                    {tripDetais?.trip_status != 5 && <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="17"
                                                      height="17"
                                                      viewBox="0 0 17 17"
                                                      fill="none"
                                                    >
                                                      <path
                                                        d="M3.64706 4.52942H2.76471C2.29668 4.52942 1.84782 4.71534 1.51687 5.04629C1.18592 5.37724 1 5.8261 1 6.29413V14.2353C1 14.7033 1.18592 15.1522 1.51687 15.4831C1.84782 15.8141 2.29668 16 2.76471 16H10.7059C11.1739 16 11.6228 15.8141 11.9537 15.4831C12.2847 15.1522 12.4706 14.7033 12.4706 14.2353V13.353"
                                                        stroke="#0049D7"
                                                        strokeWidth="1.76469"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                      />
                                                      <path
                                                        d="M11.5881 2.7648L14.2352 5.41186M15.4572 4.16333C15.8047 3.81582 16 3.34449 16 2.85304C16 2.36158 15.8047 1.89025 15.4572 1.54274C15.1097 1.19523 14.6384 1 14.1469 1C13.6555 1 13.1841 1.19523 12.8366 1.54274L5.41162 8.94128V11.5883H8.05868L15.4572 4.16333Z"
                                                        stroke="#0049D7"
                                                        strokeWidth="1.76469"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                      />
                                                    </svg>}
                                                  </button>}
                                                </div>

                                              </h4>

                                              <h4>
                                                <div className="_nW_h4Inner">
                                                  <p className="__avgFrieght">Advance Freight</p>

                                                  {tripDetais?.trip_status !== 5 && (item?.lr_status !== 6 || item?.lr_status > 6) && (
                                                    <button
                                                      className="addAble_btn addClaim"
                                                      onClick={() => openChargesHandle(item, "advance")}
                                                    >
                                                      <div className="_otrIcon_imb">
                                                        <img src={images.RUPEE} alt="" />
                                                      </div>
                                                      <span>Add Freight</span>
                                                    </button>
                                                  )}


                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                  <span className="__rtAmt">
                                                    {" "}
                                                    ₹{" "}
                                                    {/* {freghtSummary?.lr_freight?.advance_freight ? freghtSummary?.lr_freight?.advance_freight?.toFixed(
                                                      2
                                                    ) : (0).toFixed(2)} */}
                                                    {item?.lr_freight?.advance_freight ? item?.lr_freight?.advance_freight?.toFixed(
                                                      2
                                                    ) : (0).toFixed(
                                                      2
                                                    )}
                                                  </span>{" "}

                                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#panelsStayOpen-collapseOne${index}${item?._id}`} aria-expanded="true" aria-controls="panelsStayOpen-collapseOne"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      const dropdownId = `${index}${item?._id}advance`;
                                                      toggleDropdown(dropdownId);
                                                    }}>
                                                    <BsChevronDown
                                                      className={
                                                        openDropdowns.includes(`${index}${item?._id}advance`) ? "rotate-180" : ""
                                                      }
                                                      style={{ transition: "transform 0.3s ease" }}
                                                    />
                                                  </button>
                                                </div>
                                              </h4>

                                              <div id={`panelsStayOpen-collapseOne${index}${item?._id}`} class="accordion-collapse collapse " aria-labelledby="panelsStayOpen-headingOne">
                                                <div className="accordion-body">
                                                  <table className="ctmTable _trpTable_xd __nwdChn_flxTb">
                                                    <tbody>
                                                      {item?.transactions
                                                        ?.advance_freight?.length >
                                                        0 ? (
                                                        item?.transactions?.advance_freight?.map(
                                                          (k, indexk) => {
                                                            return (
                                                              <tr
                                                                key={`${indexk}_${k?._id}`}
                                                                onClick={() =>
                                                                  setPaymentVoucherOpen(
                                                                    k
                                                                  )
                                                                }
                                                              >
                                                                <td>
                                                                  <span>
                                                                    {utils?.formatDateMonth(
                                                                      k?.date
                                                                    )}
                                                                  </span>
                                                                  <br />

                                                                  <div>Date</div>
                                                                </td>

                                                                <td>
                                                                  <span className="sameSpan">
                                                                    {k?.voucher_no}
                                                                    <br />
                                                                    <div>
                                                                      Voucher
                                                                    </div>
                                                                    {k?.file
                                                                      ?.length >
                                                                      0 && (
                                                                        <div
                                                                          className="anvAttach_file"
                                                                          onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            setShowAttachedModal(
                                                                              (
                                                                                pre
                                                                              ) => ({

                                                                                ...pre,
                                                                                open: true,
                                                                                data: k?.file,
                                                                              })
                                                                            )
                                                                          }
                                                                          }
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                        >{`Attachment (${ k?.file
                                                                            ?.length
                                                                         
                                                                          })`}</div>
                                                                      )}
                                                                  </span>
                                                                </td>

                                                                <td>
                                                                  <span className="sameSpan fw-400">
                                                                    <>
                                                                      <div className="">
                                                                        {k?.sub_type_name
                                                                          ? `${k?.sub_type_name}`
                                                                          : k?.type_name}{" "}
                                                                        {k?.approval_status !=
                                                                          0 && (
                                                                            <span
                                                                              className={`tagBxs ${k?.approval_status ===
                                                                                1
                                                                                ? "pending"
                                                                                : k?.approval_status ===
                                                                                  2
                                                                                  ? "hold"
                                                                                  : k?.approval_status ===
                                                                                    2
                                                                                    ? "approved"
                                                                                    : k?.approval_status ===
                                                                                      4
                                                                                      ? "rejected"
                                                                                      : k?.approval_status ===
                                                                                        5
                                                                                        ? "complete"
                                                                                        : ""
                                                                                }`}
                                                                            >
                                                                              {" "}
                                                                              {
                                                                                masterData
                                                                                  ?.payment_approval_status[
                                                                                k
                                                                                  ?.approval_status
                                                                                ]
                                                                              }
                                                                            </span>
                                                                          )}
                                                                      </div>
                                                                      <div>
                                                                        {k?.trip
                                                                          ?.route_name
                                                                          ? `${k?.trip?.route_name}`
                                                                          : ""}{" "}
                                                                        {k?.trip
                                                                          ?.route_name &&
                                                                          k?.trip
                                                                            ?.trip_number
                                                                          ? " | "
                                                                          : ""}
                                                                        {
                                                                          k?.trip
                                                                            ?.trip_number
                                                                        }{" "}
                                                                      </div>
                                                                    </>
                                                                  </span>

                                                                </td>

                                                                <td className="sameSpan">
                                                                  {getCategoriesNames(
                                                                    k
                                                                  )}
                                                                  <div>
                                                                    Category
                                                                  </div>
                                                                </td>
                                                                <td className="sameSpan">
                                                                  <>
                                                                    <div className="fBold">
                                                                      <>
                                                                        <span className="sameSpan fw-400">
                                                                          {globTripDetails?.vehicle_ownership ==
                                                                            2 ? (
                                                                            <>
                                                                              <div>
                                                                                {k
                                                                                  ?.from_account
                                                                                  ?.sub_category
                                                                                  ?.name
                                                                                  ? k
                                                                                    ?.from_account
                                                                                    ?.sub_category
                                                                                    ?.name
                                                                                  : ""}{" "}
                                                                              </div>
                                                                              <div className="fBold">
                                                                                {k
                                                                                  ?.from_account
                                                                                  ?.name
                                                                                  ? k
                                                                                    ?.from_account
                                                                                    ?.name
                                                                                  : ""}
                                                                              </div>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <div>
                                                                                {k
                                                                                  ?.from_account
                                                                                  ?.sub_category
                                                                                  ?.name
                                                                                  ? k
                                                                                    ?.from_account
                                                                                    ?.sub_category
                                                                                    ?.name
                                                                                  : ""}{" "}
                                                                              </div>
                                                                              <div className="fBold">
                                                                                {k
                                                                                  ?.from_account
                                                                                  ?.name
                                                                                  ? k
                                                                                    ?.from_account
                                                                                    ?.name
                                                                                  : ""}
                                                                              </div>
                                                                            </>
                                                                          )}
                                                                        </span>
                                                                        <div>
                                                                          From
                                                                          Account
                                                                        </div>
                                                                      </>
                                                                    </div>

                                                                  </>
                                                                </td>
                                                                <td>
                                                                  <div>
                                                                    {
                                                                      k?.account_sub_category_name
                                                                    }
                                                                  </div>
                                                                  <div className="fBold">
                                                                    {k?.to_account
                                                                      ?.name
                                                                      ? k
                                                                        ?.to_account
                                                                        ?.name
                                                                      : ""}
                                                                  </div>
                                                                  <div>
                                                                    To Account
                                                                  </div>
                                                                </td>

                                                                <td>
                                                                  <div
                                                                    style={{
                                                                      textAlign:
                                                                        "right",
                                                                      paddingRight:
                                                                        "6px",
                                                                    }}
                                                                  >
                                                                    <span className="sameSpan">
                                                                      ₹{" "}
                                                                      {k?.total_amount.toFixed(
                                                                        2
                                                                      )}
                                                                    </span>
                                                                  </div>
                                                                </td>

                                                                <td align="right">
                                                                  <div className="_rSide_drp">
                                                                    <div className="signDropdown">
                                                                      <button className="dropbtn11" >
                                                                        <svg
                                                                          xmlns="http://www.w3.org/2000/svg"
                                                                          width="25"
                                                                          height="25"
                                                                          viewBox="0 0 25 25"
                                                                          fill="none"

                                                                        >
                                                                          <rect
                                                                            x="0.390625"
                                                                            y="0.390625"
                                                                            width="24.2188"
                                                                            height="24.2188"
                                                                            rx="2.73438"
                                                                            stroke="#0049D7"
                                                                            strokeWidth="0.78125"
                                                                          />
                                                                          <path
                                                                            d="M12.5 7.8125C13.3629 7.8125 14.0625 7.11295 14.0625 6.25C14.0625 5.38706 13.3629 4.6875 12.5 4.6875C11.6371 4.6875 10.9375 5.38706 10.9375 6.25C10.9375 7.11295 11.6371 7.8125 12.5 7.8125Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                          <path
                                                                            d="M12.5 14.0625C13.3629 14.0625 14.0625 13.3629 14.0625 12.5C14.0625 11.6371 13.3629 10.9375 12.5 10.9375C11.6371 10.9375 10.9375 11.6371 10.9375 12.5C10.9375 13.3629 11.6371 14.0625 12.5 14.0625Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                          <path
                                                                            d="M12.5 20.3125C13.3629 20.3125 14.0625 19.6129 14.0625 18.75C14.0625 17.8871 13.3629 17.1875 12.5 17.1875C11.6371 17.1875 10.9375 17.8871 10.9375 18.75C10.9375 19.6129 11.6371 20.3125 12.5 20.3125Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                        </svg>
                                                                      </button>
                                                                      {tripDetais?.trip_status != 5 && <>

                                                                        {item?.lr_status != 6 && <div className="dropdownContent">
                                                                          <Link
                                                                            // to={`/setting/user/adduser/${item?.user_id?._id}`}
                                                                            className="_avPointer"
                                                                            style={{
                                                                              textDecoration:
                                                                                "none",
                                                                            }}
                                                                            onClick={(
                                                                              e
                                                                            ) => {
                                                                              e.stopPropagation();
                                                                            }}
                                                                          >
                                                                            <span className="_samAnchor">
                                                                              <span className="viewIcon_avt">
                                                                                <FiEdit />
                                                                              </span>{" "}
                                                                              Edit
                                                                            </span>
                                                                          </Link>

                                                                          <div
                                                                            onClick={(
                                                                              e
                                                                            ) => {
                                                                              e.stopPropagation();
                                                                              handleDelteSubmit(
                                                                                k
                                                                              );
                                                                            }}
                                                                            className="_avPointer"
                                                                          >
                                                                            <span className="_samAnchor">
                                                                              <span className="deleteIcon_avt">
                                                                                <FaRegTrashCan color="red" />
                                                                              </span>{" "}
                                                                              Delete
                                                                            </span>
                                                                          </div>
                                                                        </div>}
                                                                      </>}
                                                                    </div>
                                                                  </div>
                                                                </td>
                                                              </tr>
                                                            );
                                                          }
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <NoTransactionRow />
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>

                                            <div id="panelsStayOpen-headingTwo">
                                              <h4>
                                                <div className="_nW_h4Inner">
                                                  <p className="__avgFrieght">Party Claims</p>
                                                  {tripDetais?.trip_status !== 5 && (item?.lr_status !== 6 || item?.lr_status > 6) && (<button
                                                    className="addAble_btn addClaim"
                                                    onClick={() =>
                                                      openClaimHandle(item)
                                                    }
                                                  >
                                                    <div className="_otrIcon_imb">
                                                      <img
                                                        src={images.CLAIMNEW.default}
                                                        alt=""
                                                      />
                                                    </div>
                                                    <span>Add Claims</span>
                                                  </button>)}
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                  <span className="__rtAmt">
                                                    ₹{" "}
                                                    {(
                                                      item?.lr_freight?.receivable -
                                                      item?.lr_freight?.payble
                                                    ).toFixed(2)}


                                                  </span>{" "}

                                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#panelsStayOpen-collapseTwo${index}${item?._id}`} aria-expanded="false"
                                                    aria-controls={`panelsStayOpen-collapseTwo${index}${item?._id}`}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      const dropdownId = `${index}${item?._id}claim`;
                                                      toggleDropdown(dropdownId);
                                                    }}>
                                                    <BsChevronDown
                                                      className={
                                                        openDropdowns.includes(`${index}${item?._id}claim`) ? "rotate-180" : ""
                                                      }
                                                      style={{ transition: "transform 0.3s ease" }}
                                                    />
                                                  </button>
                                                </div>
                                              </h4>

                                              <div id={`panelsStayOpen-collapseTwo${index}${item?._id}`} class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                                                <div className="accordion-body">
                                                  <table className="ctmTable _trpTable_xd __nwdChn_flxTb">
                                                    <tbody>
                                                      {item?.transactions?.claims
                                                        ?.length > 0 ? (
                                                        item?.transactions?.claims?.map(
                                                          (k, indexk) => {
                                                            return (
                                                              <tr
                                                                key={`${indexk}_${k?._id}`}
                                                                onClick={() =>
                                                                  setPaymentVoucherOpen(
                                                                    k
                                                                  )
                                                                }
                                                              >
                                                                <td>
                                                                  <span>
                                                                    {utils?.formatDateMonth(
                                                                      k?.date
                                                                    )}
                                                                  </span>
                                                                  <br />
                                                                  <div>Date</div>
                                                                </td>

                                                                <td>
                                                                  <span className="sameSpan">
                                                                    {k?.voucher_no}
                                                                  </span>
                                                                  <br />
                                                                  <div>Voucher</div>
                                                                  {k?.file?.length >
                                                                    0 && (
                                                                      <div
                                                                        className="anvAttach_file"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation()
                                                                          setShowAttachedModal(
                                                                            (
                                                                              pre
                                                                            ) => ({
                                                                              ...pre,
                                                                              open: true,
                                                                              data: k?.file,
                                                                            })
                                                                          )
                                                                        }
                                                                        }
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                      >{`Attachment (${ k?.file
                                                                          ?.length
                                                                       
                                                                        })`}</div>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                  <span className="sameSpan fw-400">
                                                                    <>
                                                                      <div className="">
                                                                        {k?.sub_type_name
                                                                          ? `${k?.sub_type_name}`
                                                                          : k?.type_name}{" "}
                                                                        {k?.approval_status !=
                                                                          0 && (
                                                                            <span
                                                                              className={`tagBxs ${k?.approval_status ===
                                                                                1
                                                                                ? "pending"
                                                                                : k?.approval_status ===
                                                                                  2
                                                                                  ? "hold"
                                                                                  : k?.approval_status ===
                                                                                    2
                                                                                    ? "approved"
                                                                                    : k?.approval_status ===
                                                                                      4
                                                                                      ? "rejected"
                                                                                      : k?.approval_status ===
                                                                                        5
                                                                                        ? "complete"
                                                                                        : ""
                                                                                }`}
                                                                            >
                                                                              {" "}
                                                                              {
                                                                                masterData
                                                                                  ?.payment_approval_status[
                                                                                k
                                                                                  ?.approval_status
                                                                                ]
                                                                              }
                                                                            </span>
                                                                          )}

                                                                      </div>

                                                                      <div>
                                                                        {k?.trip
                                                                          ?.route_name
                                                                          ? `${k?.trip?.route_name}`
                                                                          : ""}{" "}
                                                                        {k?.trip
                                                                          ?.route_name &&
                                                                          k?.trip
                                                                            ?.trip_number
                                                                          ? " | "
                                                                          : ""}
                                                                        {
                                                                          k?.trip
                                                                            ?.trip_number
                                                                        }{" "}
                                                                      </div>

                                                                      {Number(k?.sub_type) === 2 && (k?.billraise_status === 0 || k?.billraise_status === 1) && (
                                                                        <span
                                                                          className={`tagBxs ${k?.billraise_status === 1 ? "approved" : "pending"
                                                                            }`}
                                                                        >
                                                                          {k?.billraise_status === 1 ? "Bill Raised" : "Bill Pending"}
                                                                        </span>
                                                                      )}

                                                                      {Number(k?.sub_type) === 1 && k?.billraise_status === 1 && (
                                                                        <span
                                                                          className={`tagBxs ${k?.billraise_status === 1 ? "approved" : ""
                                                                            }`}
                                                                        >
                                                                          {k?.billraise_status === 1 && "Bill Received"}
                                                                        </span>
                                                                      )}
                                                                    </>
                                                                  </span>

                                                                </td>
                                                                <td className="sameSpan">
                                                                  {getCategoriesNames(
                                                                    k
                                                                  )}
                                                                  <div>
                                                                    Category
                                                                  </div>
                                                                </td>
                                                                <td className="sameSpan">
                                                                  <>
                                                                    <div className="fBold">
                                                                      <>
                                                                        <span className="sameSpan fw-400">
                                                                          {globTripDetails?.vehicle_ownership ==
                                                                            2 ? (
                                                                            <>
                                                                              <div>
                                                                                {k
                                                                                  ?.from_account
                                                                                  ?.sub_category
                                                                                  ?.name
                                                                                  ? k
                                                                                    ?.from_account
                                                                                    ?.sub_category
                                                                                    ?.name
                                                                                  : ""}{" "}
                                                                              </div>
                                                                              <div className="fBold">
                                                                                {k
                                                                                  ?.from_account
                                                                                  ?.name
                                                                                  ? k
                                                                                    ?.from_account
                                                                                    ?.name
                                                                                  : ""}
                                                                              </div>
                                                                            </>
                                                                          ) : (
                                                                            <>
                                                                              <div>
                                                                                {k
                                                                                  ?.from_account
                                                                                  ?.sub_category
                                                                                  ?.name
                                                                                  ? k
                                                                                    ?.from_account
                                                                                    ?.sub_category
                                                                                    ?.name
                                                                                  : ""}{" "}
                                                                              </div>
                                                                              <div className="fBold">
                                                                                {k
                                                                                  ?.from_account
                                                                                  ?.name
                                                                                  ? k
                                                                                    ?.from_account
                                                                                    ?.name
                                                                                  : ""}
                                                                              </div>
                                                                            </>
                                                                          )}
                                                                        </span>
                                                                        <div>
                                                                          From
                                                                          Account
                                                                        </div>
                                                                      </>
                                                                    </div>
                                                                  </>
                                                                </td>
                                                                <td>
                                                                  <span className="sameSpan fw-400">
                                                                    <div>
                                                                      {
                                                                        k?.account_sub_category_name
                                                                      }
                                                                    </div>
                                                                    <div className="fBold">
                                                                      {k?.to_account
                                                                        ?.name
                                                                        ? k
                                                                          ?.to_account
                                                                          ?.name
                                                                        : ""}
                                                                    </div>
                                                                  </span>
                                                                  <div>
                                                                    To Account{" "}
                                                                  </div>
                                                                </td>

                                                                <td>
                                                                  <div
                                                                    style={{
                                                                      textAlign:
                                                                        "right",
                                                                      paddingRight:
                                                                        "6px",
                                                                    }}
                                                                  >
                                                                    <span className="sameSpan">
                                                                      ₹{" "}
                                                                      {k?.total_amount.toFixed(
                                                                        2
                                                                      )}
                                                                    </span>
                                                                  </div>
                                                                </td>
                                                                <td align="right">
                                                                  <div className="_rSide_drp">
                                                                    <div className="signDropdown">
                                                                      <button className="dropbtn11">
                                                                        <svg
                                                                          xmlns="http://www.w3.org/2000/svg"
                                                                          width="25"
                                                                          height="25"
                                                                          viewBox="0 0 25 25"
                                                                          fill="none"
                                                                        >
                                                                          <rect
                                                                            x="0.390625"
                                                                            y="0.390625"
                                                                            width="24.2188"
                                                                            height="24.2188"
                                                                            rx="2.73438"
                                                                            stroke="#0049D7"
                                                                            strokeWidth="0.78125"
                                                                          />
                                                                          <path
                                                                            d="M12.5 7.8125C13.3629 7.8125 14.0625 7.11295 14.0625 6.25C14.0625 5.38706 13.3629 4.6875 12.5 4.6875C11.6371 4.6875 10.9375 5.38706 10.9375 6.25C10.9375 7.11295 11.6371 7.8125 12.5 7.8125Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                          <path
                                                                            d="M12.5 14.0625C13.3629 14.0625 14.0625 13.3629 14.0625 12.5C14.0625 11.6371 13.3629 10.9375 12.5 10.9375C11.6371 10.9375 10.9375 11.6371 10.9375 12.5C10.9375 13.3629 11.6371 14.0625 12.5 14.0625Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                          <path
                                                                            d="M12.5 20.3125C13.3629 20.3125 14.0625 19.6129 14.0625 18.75C14.0625 17.8871 13.3629 17.1875 12.5 17.1875C11.6371 17.1875 10.9375 17.8871 10.9375 18.75C10.9375 19.6129 11.6371 20.3125 12.5 20.3125Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                        </svg>
                                                                      </button>

                                                                      {tripDetais?.trip_status !== 5 && <>
                                                                        {k?.billraise_status !== 1 && <div className="dropdownContent">
                                                                          <Link
                                                                            // to={`/setting/user/adduser/${item?.user_id?._id}`}
                                                                            className="_avPointer"
                                                                            style={{
                                                                              textDecoration:
                                                                                "none",
                                                                            }}
                                                                            onClick={(
                                                                              e
                                                                            ) => {
                                                                              e.stopPropagation();
                                                                            }}
                                                                          >
                                                                            <span className="_samAnchor">
                                                                              <span className="viewIcon_avt">
                                                                                <FiEdit />
                                                                              </span>{" "}
                                                                              Edit
                                                                            </span>
                                                                          </Link>

                                                                          <div
                                                                            onClick={(
                                                                              e
                                                                            ) => {
                                                                              e.stopPropagation();
                                                                              handleDelteSubmit(
                                                                                k
                                                                              );
                                                                            }}
                                                                            className="_avPointer"
                                                                          >
                                                                            <span className="_samAnchor">
                                                                              <span className="deleteIcon_avt">
                                                                                <FaRegTrashCan color="red" />
                                                                              </span>{" "}
                                                                              Delete
                                                                            </span>
                                                                          </div>
                                                                        </div>}
                                                                      </>}
                                                                    </div>
                                                                  </div>
                                                                </td>
                                                              </tr>
                                                            );
                                                          }
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <NoTransactionRow />
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>

                                            <div id="panelsStayOpen-headingThree">
                                              <h4>
                                                <div className="_nW_h4Inner">
                                                  <p className="__avgFrieght">Balance Freight</p>
                                                  {tripDetais?.trip_status !== 5 && (item?.lr_status !== 6 || item?.lr_status > 6) && (<button
                                                    // disabled={item?.lr_status == 6}
                                                    className="addAble_btn addClaim"
                                                    onClick={() =>
                                                      openChargesHandle(
                                                        item,
                                                        "balance"
                                                      )
                                                    }
                                                  >
                                                    <div className="_otrIcon_imb">
                                                      <img
                                                        src={images.RUPEE}
                                                        alt=""
                                                      />
                                                    </div>
                                                    <span>Add Balance</span>
                                                  </button>)}
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                  <span className="__rtAmt">
                                                    ₹{" "}
                                                    {item?.lr_freight?.balance_freight ? item?.lr_freight?.balance_freight?.toFixed(
                                                      2
                                                    ) : (0).toFixed(2)}
                                                  </span>{" "}

                                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#panelsStayOpen-collapseThree${index}${item?._id}`}
                                                    aria-expanded="false" aria-controls={`panelsStayOpen-collapseThree${index}${item?._id}`}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      const dropdownId = `${index}${item?._id}balance`;
                                                      toggleDropdown(dropdownId);
                                                    }}>
                                                    <BsChevronDown
                                                      className={
                                                        openDropdowns.includes(`${index}${item?._id}balance`) ? "rotate-180" : ""
                                                      }
                                                      style={{ transition: "transform 0.3s ease" }}
                                                    />
                                                  </button>
                                                </div>
                                              </h4>

                                              <div id={`panelsStayOpen-collapseThree${index}${item?._id}`} class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                                                <div className="accordion-body">
                                                  <table className="ctmTable _trpTable_xd __nwdChn_flxTb">
                                                    <tbody>
                                                      {item?.transactions
                                                        ?.balance_freight?.length >
                                                        0 ? (
                                                        item?.transactions?.balance_freight?.map(
                                                          (k, indexk) => {
                                                            return (
                                                              <tr
                                                                key={`${indexk}_${k?._id}`}
                                                                onClick={(e) => {
                                                                  e.stopPropagation()
                                                                  setPaymentVoucherOpen(
                                                                    k
                                                                  )
                                                                }
                                                                }
                                                              >
                                                                <td>
                                                                  <span>
                                                                    {utils?.formatDateMonth(
                                                                      k?.date
                                                                    )}
                                                                  </span>
                                                                  <br />
                                                                  <div>Date</div>
                                                                </td>

                                                                <td>
                                                                  <span className="sameSpan">
                                                                    {k?.voucher_no}
                                                                  </span>
                                                                  <div>Voucher</div>


                                                                  {k?.file?.length >
                                                                    0 && (
                                                                      <div
                                                                        className="anvAttach_file"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation()
                                                                          setShowAttachedModal(
                                                                            (
                                                                              pre
                                                                            ) => ({
                                                                              ...pre,
                                                                              open: true,
                                                                              data: k?.file,
                                                                            })
                                                                          )
                                                                        }
                                                                        }
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                      >{`Attachment (${k?.file
                                                                          ?.length
                                                                        
                                                                        })`}</div>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                  <span className="sameSpan fw-400">
                                                                    <>

                                                                      <div className="">
                                                                        {k?.sub_type_name
                                                                          ? `${k?.sub_type_name}`
                                                                          : k?.type_name}{" "}
                                                                        {k?.approval_status !=
                                                                          0 && (
                                                                            <span
                                                                              className={`tagBxs ${k?.approval_status ===
                                                                                1
                                                                                ? "pending"
                                                                                : k?.approval_status ===
                                                                                  2
                                                                                  ? "hold"
                                                                                  : k?.approval_status ===
                                                                                    2
                                                                                    ? "approved"
                                                                                    : k?.approval_status ===
                                                                                      4
                                                                                      ? "rejected"
                                                                                      : k?.approval_status ===
                                                                                        5
                                                                                        ? "complete"
                                                                                        : ""
                                                                                }`}
                                                                            >
                                                                              {" "}
                                                                              {
                                                                                masterData
                                                                                  ?.payment_approval_status[
                                                                                k
                                                                                  ?.approval_status
                                                                                ]
                                                                              }
                                                                            </span>
                                                                          )}
                                                                      </div>

                                                                      <div>
                                                                        {k?.trip
                                                                          ?.route_name
                                                                          ? `${k?.trip?.route_name}`
                                                                          : ""}{" "}
                                                                        {k?.trip
                                                                          ?.route_name &&
                                                                          k?.trip
                                                                            ?.trip_number
                                                                          ? " | "
                                                                          : ""}
                                                                        {
                                                                          k?.trip
                                                                            ?.trip_number
                                                                        }{" "}
                                                                      </div>
                                                                      {((k?.type == 19 || k?.type == 20) && k?.billraise_status == 1) && <span
                                                                        className={`tagBxs approved 
                                                                        `}
                                                                      >
                                                                        {" "}
                                                                        Bill Received
                                                                      </span>}
                                                                    </>
                                                                  </span>

                                                                </td>
                                                                <td className="sameSpan">
                                                                  {getCategoriesNames(
                                                                    k
                                                                  )}
                                                                  <div>
                                                                    Category
                                                                  </div>
                                                                </td>
                                                                <td className="sameSpan">
                                                                  <>
                                                                    <div className="fBold">
                                                                      <span className="sameSpan fw-400">
                                                                        {globTripDetails?.vehicle_ownership ==
                                                                          2 ? (
                                                                          <>
                                                                            <div>
                                                                              {k
                                                                                ?.from_account
                                                                                ?.sub_category
                                                                                ?.name
                                                                                ? k
                                                                                  ?.from_account
                                                                                  ?.sub_category
                                                                                  ?.name
                                                                                : ""}{" "}
                                                                            </div>
                                                                            <div className="fBold">
                                                                              {k
                                                                                ?.from_account
                                                                                ?.name
                                                                                ? k
                                                                                  ?.from_account
                                                                                  ?.name
                                                                                : ""}
                                                                            </div>
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            <div>
                                                                              {k
                                                                                ?.from_account
                                                                                ?.sub_category
                                                                                ?.name
                                                                                ? k
                                                                                  ?.from_account
                                                                                  ?.sub_category
                                                                                  ?.name
                                                                                : ""}{" "}
                                                                            </div>
                                                                            <div className="fBold">
                                                                              {k
                                                                                ?.from_account
                                                                                ?.name
                                                                                ? k
                                                                                  ?.from_account
                                                                                  ?.name
                                                                                : ""}
                                                                            </div>
                                                                          </>
                                                                        )}
                                                                      </span>
                                                                      <>
                                                                        <div>
                                                                          From
                                                                          Account
                                                                        </div>
                                                                      </>
                                                                    </div>
                                                                  </>
                                                                </td>
                                                                <td>
                                                                  <div>
                                                                    {
                                                                      k?.account_sub_category_name
                                                                    }
                                                                  </div>
                                                                  <div className="fBold">
                                                                    {k?.to_account
                                                                      ?.name
                                                                      ? k
                                                                        ?.to_account
                                                                        ?.name
                                                                      : ""}
                                                                  </div>
                                                                  <div>
                                                                    To Account
                                                                  </div>
                                                                </td>

                                                                <td>
                                                                  <div
                                                                    style={{
                                                                      textAlign:
                                                                        "right",
                                                                      paddingRight:
                                                                        "6px",
                                                                    }}
                                                                  >
                                                                    <span className="sameSpan">
                                                                      ₹{" "}
                                                                      {k?.total_amount.toFixed(
                                                                        2
                                                                      )}
                                                                    </span>
                                                                  </div>
                                                                </td>
                                                                <td align="right">
                                                                  <div className="_rSide_drp">
                                                                    <div className="signDropdown">
                                                                      <button className="dropbtn11">
                                                                        <svg
                                                                          xmlns="http://www.w3.org/2000/svg"
                                                                          width="25"
                                                                          height="25"
                                                                          viewBox="0 0 25 25"
                                                                          fill="none"
                                                                        >
                                                                          <rect
                                                                            x="0.390625"
                                                                            y="0.390625"
                                                                            width="24.2188"
                                                                            height="24.2188"
                                                                            rx="2.73438"
                                                                            stroke="#0049D7"
                                                                            strokeWidth="0.78125"
                                                                          />
                                                                          <path
                                                                            d="M12.5 7.8125C13.3629 7.8125 14.0625 7.11295 14.0625 6.25C14.0625 5.38706 13.3629 4.6875 12.5 4.6875C11.6371 4.6875 10.9375 5.38706 10.9375 6.25C10.9375 7.11295 11.6371 7.8125 12.5 7.8125Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                          <path
                                                                            d="M12.5 14.0625C13.3629 14.0625 14.0625 13.3629 14.0625 12.5C14.0625 11.6371 13.3629 10.9375 12.5 10.9375C11.6371 10.9375 10.9375 11.6371 10.9375 12.5C10.9375 13.3629 11.6371 14.0625 12.5 14.0625Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                          <path
                                                                            d="M12.5 20.3125C13.3629 20.3125 14.0625 19.6129 14.0625 18.75C14.0625 17.8871 13.3629 17.1875 12.5 17.1875C11.6371 17.1875 10.9375 17.8871 10.9375 18.75C10.9375 19.6129 11.6371 20.3125 12.5 20.3125Z"
                                                                            fill="#0049D7"
                                                                          />
                                                                        </svg>
                                                                      </button>
                                                                      {tripDetais?.trip_status !== 5 && <>

                                                                        {item?.lr_status != 6 &&
                                                                          <div className="dropdownContent">
                                                                            <Link
                                                                              // to={`/setting/user/adduser/${item?.user_id?._id}`}
                                                                              className="_avPointer"
                                                                              style={{
                                                                                textDecoration:
                                                                                  "none",
                                                                              }}
                                                                              onClick={(
                                                                                e
                                                                              ) => {
                                                                                e.stopPropagation();
                                                                              }}
                                                                            >
                                                                              <span className="_samAnchor">
                                                                                <span className="viewIcon_avt">
                                                                                  <FiEdit />
                                                                                </span>{" "}
                                                                                Edit
                                                                              </span>
                                                                            </Link>

                                                                            <div
                                                                              onClick={(
                                                                                e
                                                                              ) => {
                                                                                e.stopPropagation();
                                                                                handleDelteSubmit(
                                                                                  k
                                                                                );
                                                                              }}
                                                                              className="_avPointer"
                                                                            >
                                                                              <span className="_samAnchor">
                                                                                <span className="deleteIcon_avt">
                                                                                  <FaRegTrashCan color="red" />
                                                                                </span>{" "}
                                                                                Delete
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        }
                                                                      </>}
                                                                    </div>
                                                                  </div>
                                                                </td>
                                                              </tr>
                                                            );
                                                          }
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <NoTransactionRow />
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>

                                          </div>


                                          {/* Map End */}

                                          <h4
                                            style={{
                                              borderBottom: "1px solid #d9e6ef", paddingRight: '3.26em'
                                            }}
                                          >
                                            Total TDS{" "}
                                            <span className="__rtAmt">
                                              {" "}
                                              ₹{" "}
                                              {item?.lr_freight?.total_tds ? item?.lr_freight?.total_tds?.toFixed(
                                                2
                                              ) : "0.00"}
                                            </span>{" "}
                                          </h4>

                                          <h4
                                            style={{
                                              borderBottom: "1px solid #d9e6ef", paddingRight: '3.26em'
                                            }}
                                          >
                                            GST {item?.lr_freight?.gst_deduction ? `${item?.lr_freight?.gst_deduction}%` : ""}
                                            <span className="__rtAmt">
                                              {" "}
                                              ₹{" "}
                                              {item?.lr_freight?.total_gst ? item?.lr_freight?.total_gst?.toFixed(
                                                2
                                              ) : "0.00"}
                                            </span>{" "}
                                          </h4>
                                          <h4
                                            style={{
                                              borderBottom: "1px solid #d9e6ef", paddingRight: '3.26em'
                                            }}
                                          >
                                            Balance{" "}
                                            <span className="__rtAmt">
                                              {" "}
                                              ₹{" "}
                                              {item?.lr_freight?.balance ? item?.lr_freight?.balance?.toFixed(
                                                2
                                              ) : "0.00"}
                                            </span>{" "}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        ) : (
                          <>
                            {tripDetais?.trip_status != 5 && <div
                              className="__addLoad_btnFx"
                              onClick={() => {
                                SetSelectLRListID(main?._id);
                                setSelectParty(true)
                              }}
                            >
                              <button>+ Add your Load</button>
                            </div>}
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : flag ? (
        <div className="loaderBg" style={{ textAlign: "center" }}><Loading /></div>
      ) : (
        <>No Data</>
      )}

      {isOpenCharge?.open && <AddChargeModal {...chargeProps} />}
      {isOpenClaim && <AddClaimForConsignor {...claimProps} />}
      {canvasOpen && <BankListCanvas {...bankListProps} />}
      {showAddBank && <AddBankAccount {...firstAddBank} />}
      {isOpenExpense.open && <OtherExpenseModal {...otherExpenseProps} />}
      {editLrAmount && <EditConsignorFreight {...addTotalProps} />}
      {showAttachedModal?.open && <AttachedFileModal {...attachedModal} />}
      <div
        className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showLrDetail ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showLrDetail ? "visible" : "hidden" }}
      >
        {showLrDetail && (
          <LrDetailModal
            isOpen={showLrDetail}
            onClose={(e) => setShowLrDetail(false)}
            nextModal={(e) => handleNextModal(e)}
          />
        )}
      </div>
      <div className={showLrDetail ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showAddLR ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showAddLR ? "visible" : "hidden" }}
      >
        {showAddLR && (
          <AddEditLrModal
            isOpen={showAddLR}
            onClose={() => setShowAddLR(false)}
            callBackDataLr={callBackDataLr}
            type="from_trip"
            callGetData={() => { }}
          />
        )}
      </div>
      <div className={showAddLR ? "offBack_drop" : ""}></div>

      {confirmModalShow && (
        <ConfirmModalFor {...confirmModalProps}>
          <>
            <p className="_confirmPrx">
              {" "}
              Are you sure you want to delete " {"Transaction"} "{" "}
            </p>
          </>
        </ConfirmModalFor>
      )}

      {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}

      {selectParty && <AddLrModal {...selectPartyModal} />}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isAddConsignor ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: isAddConsignor ? "visible" : "hidden" }}
      >
        {isAddConsignor && (
          <AddEditConsignor
            isOpen={isAddConsignor}
            onClose={() => setIsAddConsignor(false)}
            isPreviousModal={(e) => setSelectParty(true)}
            showingPrefield={(e) => setShowingPrefield(true)}
            hideAddNewOption={false}
            branchFirmId={consignorTransDetails?.firm_id?._id}
          />
        )}
      </div>
      <div className={isAddConsignor ? "offBack_drop" : ""}></div>

      {showSelectLr && <SelectLrForConsignor {...selectLrModalProps} />}


    </>
  );
};

export default ConsignorFreight;
